module.exports = __webpack_public_path__ + "static/img/2.58ed31e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Multirriesgo-Copropiedades/2.png
// module id = 8S6K
// module chunks = 0